portfolioHandler = {
    $carousel: $('.portfolio-carousel'),
    $mainCont: $('.main-container'),
    
    setHeight: function(){
        var self      = this;
        var newHeight    = ($(window).height() / 1.7);

        //if (Foundation.MediaQuery.is("large")) {
            /* self.$carousel.find('img.image').css({
                'height': newHeight+'px',
                'opacity': '1',
            }); */
        //}
        self.$carousel.find('.carousel-cell').each(function() {
            var imgW = document.getElementById($(this).find('.image').attr("id")).naturalWidth;
            var imgH = document.getElementById($(this).find('.image').attr("id")).naturalHeight;

            if (imgW > imgH) $(this).find('.image').addClass('is-landscape');
            /* var imgRatio = imgW / imgH;
            var screenH = $(window).height() - $('header').height() - parseFloat(self.$mainCont.css('margin-top').replace('px', '')) - parseFloat(self.$mainCont.css('padding-top').replace('px', '')) - $(this).find('.text-container').height() - parseFloat($(this).find('.cc-body').css('margin-top').replace('px', '')) - $(this).find('.cc-head').height() - parseFloat($(this).find('.image').css('margin-bottom').replace('px', ''));

            if (self.$carousel.hasClass('is-touchevents')) 
                screenH = screenH - parseFloat(self.$carousel.css('margin-bottom').replace('px', ''));

            screenH = screenH - 32;

            $(this).find('.image').css({
                'height': screenH+'px',
                'opacity': '1',
            }); */
        });
    },
 
    setCarousel: function(){
        var self = this;
        self.$carousel.each(function() {
            var $draggable = false;

            if ($('html').hasClass('touchevents') || Foundation.MediaQuery.only('medium')) {
                $draggable = true;
                $(this).addClass('is-touchevents');
                $(this).removeAttr('style');
            } else {
                var $cellPort = $(this).find('.cell-carousel:first-of-type');
                var btnTop = $cellPort.find('.cc-head').height() + parseFloat($cellPort.find('.cc-body').css('margin-top').replace('px', ''));
                $(this).css('--btn-top-space', btnTop+'px');
            }

            /* if ($(this).find('.carousel-cell').length > 1) {
                var options = {
                    cellSelector: '.carousel-cell',
                    cellAlign: 'left',
                    prevNextButtons: true,
                    draggable: $draggable,
                    imagesLoaded: true,
                    fade: true,
                    freeScroll: false,
                    pageDots: false,
                    adaptiveHeight: true,
                    wrapAround: false,
                    arrowShape: 'M 44 0 L 50.4 6.4 L 18.4 36 H 102.4 V 44.8 H 18.4 L 50.4 74.4 L 44 80.8 L 0 40.8 Z',
                };
                
                var $portfolioSlider = $(this).flickity(options);
            } */
        });
    },

    init: function() {
        var self = this;
        self.setCarousel();
        //this.setHeight();
        var winWidth = $(window).width();

        $(window).on('resize', function() {
            if ($(this).width() !== winWidth) {
                winWidth = $(this).width();
                self.setHeight();
                self.setCarousel();
            }
        });
    }
}